import { Button } from "@synthesis/shared-ui/Button";

type CancelSelectionPopupProps = {
  onConfirm: () => void;
  onCancel: () => void;
};

const CancelSelectionPopup = ({ onConfirm, onCancel }: CancelSelectionPopupProps) => (
  <div className="absolute inset-0 z-20 flex items-center justify-center" onClick={onCancel}>
    <div className="rounded-xl bg-white p-6 shadow-xl" onClick={(e) => e.stopPropagation()}>
      <h3 className="mb-4">Вы уверены, что хотите отменить выделение?</h3>
      <div className="flex items-center justify-between">
        <Button size="sm" theme="primary" onClick={onConfirm}>
          Да
        </Button>
        <Button size="sm" type="button" onClick={onCancel}>
          Нет
        </Button>
      </div>
    </div>
  </div>
);

export default CancelSelectionPopup;
